module.exports = "//static.hsappstatic.net/LoginUI/static-1.16112/img/connect.com-full-logo-color.svg"